import React from 'react';
import GoogleMap from '../../compo/GoogleMap/GoogleMap';
import './Contact.css'

const Contact = () => {
  const embedUrl = "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3719.523394820835!2d81.67086607503676!3d21.211084080484277!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a28dcdcb8953da3%3A0x70efcab1ef100bdf!2sGodriwala%20Plastics%20Private%20Limited(Pooja%20Plastic)!5e0!3m2!1sen!2sin!4v1720342205685!5m2!1sen!2sin";

 
  return (
    <>
      <div>
      <div><GoogleMap embedUrl={embedUrl} /></div>
        <div>
          <form className='contact-form'>
            <h1>CONTACT FORM</h1>
            <div className='form-group'>
              <label>FIRST NAME</label>
              <input type='text' placeholder='Enter your first name' />
            </div>
            <div className='form-group'>
              <label>LAST NAME</label>
              <input type='text' placeholder='Enter your last name' />
            </div>
            <div className='form-group'>
              <label>EMAIL</label>
              <input type='email' placeholder='Enter your email' />
            </div>
            <div className='form-group'>
              <label>PHONE NUMBER</label>
              <input type='tel' placeholder='Enter your phone number' />
            </div>
            <div className='form-group'>
              <label>MESSAGE</label>
              <textarea placeholder='Enter your message'></textarea>
            </div>
            <button type='submit'>Submit</button>
          </form>
        </div>
      </div>
    </>
  );
}

export default Contact;
